window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");
    require("bootstrap");
} catch (e) {}

/**
 * TODO: delete these three lines. Nothing reads the global any more - HTTP goes
 * through apiCall - and eslint already rejects a bare `axios`. Kept only as a
 * safety net for a consumer we may not have found.
 *
 * They are broken anyway: only layouts/app.blade.php defines `window.Laravel`,
 * so the last line is a TypeError on the twelve partner iframe pages and the
 * Echo setup below never runs there.
 */
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// Standalone pages (partner iframes) don't extend layouts/app, so window.Laravel
// is undefined there — fall back to the csrf-token meta tag they all render.
window.axios.defaults.headers.common["X-CSRF-TOKEN"] =
    window.Laravel?.csrfToken ??
    document.head.querySelector('meta[name="csrf-token"]')?.content;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.io = require("socket.io-client");

window.Echo = new Echo({
    broadcaster: "socket.io",
    //    host: window.location.hostname + ':6001',
    authEndpoint: "/broadcasting/auth",
});
